import React from "react";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
// Images
import bgImage from "assets/images/backgroundLogin.png";
import bgImageMobile from "assets/images/backgroundLoginMobile.png";
import singhCoinBrand from "assets/images/singhCoinBrand.png";

import {
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
  Stack,
  CircularProgress,
  Link,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import dialogBgImage from "assets/images/dialogBgImage.png";
import { useMediaQuery } from "react-responsive";
import CloseIcon from "@mui/icons-material/Close";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { walletDisconnect } from "Store/slices/walletSlice";
import MDAvatar from "components/MDAvatar";
import validations from "customValidations/validations";
import validationService from "customValidations/validationService";
import { signIn } from "services/userService";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import applestore from "assets/images/AppStore.png";
import googleplay from "assets/images/GooglePlay.png";

import { GoogleLogin } from "@react-oauth/google";
import { googleSignIn } from "services/userService";

import { loginUser } from "Store/slices/userAuthSlice";
import { loginDialogReducer } from "Store/slices/loginDialogSlice";

function LoginDialog({ openStatus, onClose }) {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const { openBoolean } = useSelector((state) => state.loginDialogState);

  let location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [firebaseTokenClient, setFirebaseTokenClient] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [errorMsg, setErrorMsg] = useState({
    email: { errorMsg: "" },
    password: { errorMsg: "" },
  });

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const { from } = location.state || { from: { pathname: "/" } };

  useEffect(() => {
    checkIfLoggedIn();
  }, []);

  const checkIfLoggedIn = () => {
    if (localStorage.jwtTokenSingh) {
      navigate("/");
    }
  };

  const customValidations = (name, value) => {
    let errorLength = 0;
    const args = [
      {
        name,
        value: value,
        validations: validations.signInValidations[name],
      },
    ];

    validationService.validate(args, (validationErr, validationErrMsgs) => {
      if (validationErrMsgs.length > 0) {
        errorLength = errorLength + 1;
        errorMsg[name].errorMsg = validationErrMsgs[0].validations[0].message;
        setErrorMsg({ ...errorMsg });
      } else {
        errorMsg[name].errorMsg = "";
        setErrorMsg({ ...errorMsg });
      }
    });
    return errorLength;
  };

  const handleShowPassword = () => setShowPassword(!showPassword);

  const handleInputChange = (name, value) => {
    if (name === "email") {
      setEmail(value);
    } else if (name === "password") {
      setPassword(value);
    } else {
      console.log("IputError");
    }
  };

  const handleLogin = async () => {
    let errorLengthEmail = customValidations("email", email);
    let errorLengthPassword = customValidations("password", password);

    // console.log("erremail", errorLengthEmail);
    // console.log("erropass", errorLengthPassword);
    // console.log("email", email);
    // console.log("password", password);

    if (errorLengthEmail !== 1 && errorLengthPassword !== 1) {
      // console.log("Alll okkkkkkk");
    } else {
      // console.log("Validation error");
      return;
    }

    setLoading(true);
    const userData = {
      email: email,
      password: password,
      timezone: "Asia/Calcutta",
    };

    const signInResponse = await signIn(userData);
    // console.log("signInRes", signInResponse);

    if (signInResponse.status === 200) {
      if (signInResponse.data.accountType === "Personal") {
        dispatch(loginUser(signInResponse.data));
        if (signInResponse.data.isAccountSetup) {
          dispatch(loginDialogReducer(false));
          if (location.state === null || location.state === undefined) {
            navigate(`${from.pathname}`);
          } else {
            navigate(`${from.pathname}${from.search}`);
          }
        } else {
          navigate("/setup-profile");
        }
      } else if (signInResponse.data.accountType === "Business") {
        toast.error(`Please use personal account`, {
          style: {
            fontSize: "15px",
          },
        });
      }
    } else {
      setLoading(false);
    }
  };

  const googleSuccess = async (response) => {
    // console.log("googleRes", response);

    const googleData = {
      token: response.credential,
    };

    const googleSigInApiRes = await googleSignIn(googleData);

    // console.log("googleSigInApiRes", googleSigInApiRes);

    if (googleSigInApiRes.status === 200) {
      if (googleSigInApiRes.data.accountType === "Personal") {
        dispatch(loginUser(googleSigInApiRes.data));
        if (googleSigInApiRes.data.isAccountSetup) {
          dispatch(loginDialogReducer(false));

          if (location.state === null || location.state === undefined) {
            navigate(`${from.pathname}`);
          } else {
            navigate(`${from.pathname}${from.search}`);
          }
        } else {
          navigate(`/setup-profile/?google=${true}`);
        }
      } else if (googleSigInApiRes.data.accountType === "Business") {
        toast.error(`Please use personal account`, {
          style: {
            fontSize: "15px",
          },
        });
      }
    }

    //check googleSigInApiRes

    // window.location.href = "";
    // navigate("/");
  };

  const handleNavSignUp = () => {
    dispatch(loginDialogReducer(false));
    navigate("/sign-up-personal");
  };

  return (
    <Dialog
      sx={{}}
      open={openBoolean}
      maxWidth="xs"
      fullWidth
      //   fullScreen={isTabletOrMobile && true}
      onClose={onClose}
    >
      <Card
        sx={{
          borderRadius: "1px",
          //   backgroundImage: `url(${bgImageMobile})`,
          backgroundSize: "cover",
          backgroundColor: "#ebebeb",
          boxShadow: "none",
        }}
      >
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            sx={{
              marginBottom: "2rem",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <MDAvatar
              src={singhCoinBrand}
              sx={{ height: "100px", width: "100px" }}
            />
          </MDBox>
          <MDBox role="form">
            <MDBox mb={2}>
              <TextField
                fullWidth
                // type="email"
                name="email"
                label="Email"
                inputProps={{
                  style: { color: "#000000" },
                }}
                // InputLabelProps={{ style: { fontFamily: "Poppins" } }}
                error={errorMsg.email.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.email.errorMsg}
              />
            </MDBox>
            <MDBox>
              <TextField
                fullWidth
                type={showPassword ? "text" : "password"}
                label="Password"
                inputProps={{
                  style: { color: "#000000" },
                }}
                // InputLabelProps={{ style: { fontFamily: "Poppins" } }}
                name="password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => handleShowPassword()}>
                        {showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={errorMsg.password.errorMsg.length > 0}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
                helperText={errorMsg.password.errorMsg}
              />
            </MDBox>

            <MDBox>
              <MDTypography
                component={Link}
                to="/forgot-password"
                variant="button"
                fontWeight="regular"
                color="text"
                // fontFamily="Poppins"
                // onClick={handleSetRememberMe}
                sx={{ cursor: "pointer" }}
              >
                Forgot password?
              </MDTypography>
            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton color="singh" fullWidth onClick={() => handleLogin()}>
                {loading ? (
                  <CircularProgress color="inherit" size={19} />
                ) : (
                  "Sign In"
                )}
              </MDButton>
            </MDBox>

            <MDBox mt={1} mb={1} display="flex" justifyContent="center">
              <GoogleLogin
                // cilentId="402757163916-1upt7ms49vggd6kcr976krsarcgo5cqh.apps.googleusercontent.com"
                onSuccess={googleSuccess}
                onError={() => {
                  console.log("Login Failed");
                }}
                theme="filled_black"
                width="290px"
              />
            </MDBox>

            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <Link
                  // component={Link}
                  // to="/sign-up-personal"
                  // variant="button"
                  color="inherit"
                  fontWeight="medium"
                  onClick={() => handleNavSignUp()}

                  // textGradient
                >
                  Sign up
                </Link>
              </MDTypography>
            </MDBox>
            <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Get the app.
              </MDTypography>
              <Stack direction="row" justifyContent="center">
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.smartgenesis.singhcoin.singhcoin&utm_source=website&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play"
                >
                  <img
                    //  style={{ marginLeft: isDesktopOrLaptop && "55px"}}
                    src={googleplay}
                    alt="Logo"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://apps.apple.com/in/app/singhcoin/id1634159563"
                >
                  <img src={applestore} alt="Logo" />
                </a>
              </Stack>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </Dialog>
  );
}

export default LoginDialog;
